{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password",
      "ERROR": "Heslo je príliš krátke."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Confirm Password",
      "ERROR": "Passwords do not match."
    },
    "API": {
      "SUCCESS_MESSAGE": "Successfully changed the password.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "CAPTCHA": {
      "ERROR": "Verification expired. Please solve captcha again."
    },
    "SUBMIT": "Odoslať"
  }
}
